import * as XLSX from "xlsx";
import SocieteAndUserService from "../services/societeAndUser";
import ProductService from "../services/ProductService";
import getCurrentUserId from "../reduxSaga/sagas/requests/currentUserId";

/*
 * Plan limits of the Noryx edition, checked in the interface only: the
 * backend is shared with editions that have no such limit. Override with
 * REACT_APP_MAX_USERS / REACT_APP_MAX_PRODUCTS at build time; a negative value
 * removes the limit. When a count cannot be read (network, server error) the
 * action is allowed, so a technical problem never blocks a user.
 */
const readLimit = (value, fallback) => {
  const n = Number(value);
  return value !== undefined && value !== "" && Number.isFinite(n) ? n : fallback;
};

export const MAX_USERS = readLimit(process.env.REACT_APP_MAX_USERS, 5);
export const MAX_PRODUCTS = readLimit(process.env.REACT_APP_MAX_PRODUCTS, 2000);

export const isLimited = (max) => max >= 0;

export const countUsers = async () => {
  const response = await SocieteAndUserService.getAllUserPartner(0);
  const list = response.data && response.data.userResponse;
  if (!Array.isArray(list)) {
    throw new Error("users count unavailable");
  }
  return list.length;
};

export const countProducts = async () => {
  const response = await ProductService.getProductsPage(getCurrentUserId(), {
    page: 0,
    size: 1,
    isDeleted: 0,
  });
  const total = response.data && response.data.success && response.data.success.totalElements;
  if (typeof total !== "number") {
    throw new Error("products count unavailable");
  }
  return total;
};

export const usersMessage = () =>
  `Limite de votre abonnement atteinte : ${MAX_USERS} utilisateurs maximum. Contactez-nous pour augmenter votre limite.`;

export const productsMessage = (adding = 1) =>
  adding > 1
    ? `Votre abonnement est limité à ${MAX_PRODUCTS} produits : cet import dépasserait la limite. Contactez-nous pour augmenter votre limite.`
    : `Limite de votre abonnement atteinte : ${MAX_PRODUCTS} produits maximum. Contactez-nous pour augmenter votre limite.`;

/*
 * Resolves { allowed, count, max, message }. `adding` is the number of items
 * about to be created.
 */
const check = async (counter, max, messageFor, adding) => {
  if (!isLimited(max)) {
    return { allowed: true, count: null, max, message: "" };
  }
  try {
    const count = await counter();
    const allowed = count + adding <= max;
    return { allowed, count, max, message: allowed ? "" : messageFor(adding) };
  } catch (error) {
    return { allowed: true, count: null, max, message: "" };
  }
};

export const checkUserLimit = (adding = 1) => check(countUsers, MAX_USERS, usersMessage, adding);

export const checkProductLimit = (adding = 1) =>
  check(countProducts, MAX_PRODUCTS, productsMessage, adding);

// number of data rows (first row = headers) of the first sheet of an .xlsx file
export const countExcelRows = async (file) => {
  const buffer = await file.arrayBuffer();
  const workbook = XLSX.read(buffer, { type: "array" });
  let rows = 0;
  workbook.SheetNames.forEach((name) => {
    const data = XLSX.utils.sheet_to_json(workbook.Sheets[name], { header: 1, blankrows: false });
    rows += Math.max(data.length - 1, 0);
  });
  return rows;
};
